import React from "react";
import "./ProfileCards.css";

import MainButton from "../Elements/MainButton/MainButton";
import SecondButton from "../Elements/SecondButton/SecondButton";

import userIcon from "../../assets/data/user.png";

const UserSummaryCard = ({ user, onEdit, onDelete }) => {
  return (
    <section className="summary-card summary-card--user">
      <div className="summary-left">
        <div className="avatar-circle">
          <img src={userIcon} alt="User avatar" className="avatar-icon" />
        </div>
        <div>
          <p className="summary-name">{user.name}</p>
          <p className="summary-email">{user.email}</p>
          <p className="summary-role">{user.role}</p>
        </div>
      </div>

      <div className="summary-actions">
        <SecondButton className="summary-btn summary-btn--danger" onClick={onDelete}>
          Delete
        </SecondButton>
        <MainButton className="summary-btn summary-btn--primary" onClick={onEdit}>
          Edit
        </MainButton>
      </div>
    </section>
  );
};

export default UserSummaryCard;
